import { Grid } from '@material-ui/core';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import { MaintenanceFiltersSchema } from 'core/schemas/maintenanceFilters';
import { FormSubmitHandler } from 'Elements/Form';

import MaintenanceListFilters from './MaintenanceListFilters';
import MaintenanceTable from './MaintenanceTable';

const Height100 = styled.div`
  height: 100%;
`;
const Width100 = styled.div`
  width: 100%;
  max-width: 250px;
`;

export default function MaintenanceList() {
  const [params, setParams] = useState({} as MaintenanceFiltersSchema);

  const onSubmit: FormSubmitHandler<MaintenanceFiltersSchema> = useCallback(
    values => setParams(serialize(values)),
    []
  );

  return (
    <Grid container direction="row" component={Height100}>
      <Grid item xs component={Width100}>
        <MaintenanceListFilters onSubmit={onSubmit} />
      </Grid>

      <Grid item sm={12} md={8} component={Height100}>
        <MaintenanceTable params={params} />
      </Grid>
    </Grid>
  );
}

const serialize = (values: any): any => {
  const params = JSON.parse(JSON.stringify(values));

  return params;
};
